import { Row, Col, Container } from "react-bootstrap";
import React, { useEffect, useState, useContext } from "react";
import "./../TransmissionUnits/TransmissionUnits.css";
import Annexure_Ia_Bank from "../../PDF/Transmission of Units/Annexure_Ia_Bank.pdf";
import Annexure_Ib_Bank from "../../PDF/Transmission of Units/Annexure_Ib_Bank.pdf";
import Annexure_II_Bond from "../../PDF/Transmission of Units/Annexure_II_Bond.pdf";
import Annexure_III_Individual_Affidavits from "../../PDF/Transmission of Units/Annexure_III_Individual_Affidavits.pdf";
import Annexure_IV_NOC from "../../PDF/Transmission of Units/Annexure_IV_NOC.pdf";
import Annexure_VI_Bond from "../../PDF/Transmission of Units/Annexure_VI_Bond.pdf";
import Annexure_V from "../../PDF/Transmission of Units/Annexure_V.pdf";
import Form_T2_Form_for_Transmission from "../../PDF/Transmission of Units/Annexure 2 QTP without Nominee.pdf";
import From_T5_Transmission from "../../PDF/Transmission of Units/Annexure 5 Affidavit cum NOC.pdf";
import From_T1_Form_for_Deletion from "../../PDF/Transmission of Units/Annexure-1 QTP with Nominee.pdf";
import From_T3_Transmission from "../../PDF/Transmission of Units/Annexure-3 Other than QTP.pdf";
import From_T4_Transmission_Request from "../../PDF/Transmission of Units/Annexure-4 Indemnity Bond.pdf";
import MFNominationForm from "../../PDF/Transmission of Units/Nomination Form.pdf";
import guidelines from "../../PDF/Transmission of Units/AMFI-Best-Practice.pdf";
import Transmission_Grid from "../../PDF/Transmission of Units/Documentation Grid.pdf";
import Transmission from "../../PDF/Transmission of Units/Common SOP for Centralized Demise information.pdf";
import { trackEvent, trackPageView } from "../utils/tracking";


import TransmissionMatrix from "../../PDF/Transmission of Units/Transmission of Units New/Transmission Matrix.pdf"
import FormQtp1 from "../../PDF/Transmission of Units/Transmission of Units New/FORM-QTP with Nominee.pdf"
import FormQtp2 from "../../PDF/Transmission of Units/Transmission of Units New/FORM-QTP without Nominee.pdf"
import DeletionRequest from "../../PDF/Transmission of Units/Transmission of Units New/FORM-1 Request for Deletion of name(s) of Joint Holders in case of death of the 1st and 2nd Joint Holders.pdf";
import TransmissionRequest from "../../PDF/Transmission of Units/Transmission of Units New/FORM-2 Request for Transmission of Units by Surviving Joint Holder(s) on demise of 1st unit holder.pdf";
import  TransmissionRequest3 from "../../PDF/Transmission of Units/Transmission of Units New/FORM-3 Transmission Request Form (under Simplified category and other than QTP Category).pdf"
import KartaClaimaint from "../../PDF/Transmission of Units/Transmission of Units New/FORM-4 Transmission to New Karta_Claimant (on death of HUF Karta or on Dissolution of HUF).pdf"
import BondOfIndeminity from "../../PDF/Transmission of Units/Transmission of Units New/BOND OF INDEMNITY.pdf"
import BondOfIndeminityKarta from "../../PDF/Transmission of Units/Transmission of Units New/BOND OF INDEMNITY-Change of Karta.pdf"
import BankDetails from "../../PDF/Transmission of Units/Transmission of Units New/Bank Attestation of Signature and bank account details.pdf"
import BankDetailsNewKarta from "../../PDF/Transmission of Units/Transmission of Units New/Bank Attestation of Signature of new Karta.pdf"
import AffidavitNOC from "../../PDF/Transmission of Units/Transmission of Units New/Affidavit cum NOC.pdf"


function TransmissionUnits() {
  const [path, setPathnameURL] = useState("");
  useEffect(() => {
    var pathnameurl = window.location.pathname;
    const regEx = new RegExp("-", "g");
    const resultName = pathnameurl.replace(regEx, " ");
    setPathnameURL(resultName);
  });

  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/Transmission-Units",
      "jmf_transmission-of-units",
    );
    // trackPageView(
    //   "http://localhost:710/Transmission-Units",
    //   "jmf_transmission-of-units"
    // );

    trackEvent({
      category: "Static Page",
      action: "TransmissionUnits Page Loaded",
      label: "jmf_transmission-of-units",
      //   value: 1,
    });
  }, []);

  // let Transmission_Reckoner = 'https://prev.jmfinancialmf.com/CMT/Upload/ArticleAttachments/EB5D6709-575C-4C13-BC0B-03D53B73948C/List%20of%20Documents%20required%20for%20transmission%20under%20various%20situations%20Oct%202020.pdf'

  return (
    <>
      <main>
        <section className="Transmission-main">
          <Container>
            <Row>
              <Col>
                <ul className="navigator-arrow">
                  <li>
                    <a href="/" aria-label="Home">
                      <i class="fa fa-home" aria-hidden="true"></i>
                    </a>{" "}
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </li>
                  {/* <li><a href="/NavsAndIDCW"><i>NavsAndIDCW</i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li> */}
                  {window.location.pathname != "" ? (
                    <li>{path.replace("/", "")}</li>
                  ) : (
                    ""
                  )}
                </ul>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row>
              <Col>
                <h1>Transmission of Units process Flow</h1>
                <div className="Transmission-div">
                  <div className="trans-inner-main">
                    {/* <p>
                      Please
                      <a
                        href={Transmission}
                        className="ach"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </a>
                      the Common SOP (Standard Operating Procedure) for
                      reporting the demise of an investor through KRAs.
                    </p>
                    <p>
                      Please
                      <a
                        href={Transmission_Grid}
                        className="ach"
                        target="blank"
                      >
                        View
                      </a>
                      Transmission Documentation Grid.
                    </p> */}
                  </div>
                  <div className="trans-inner">
                    {/* <p>
                      Please{" "}
                      <a href={guidelines} className="ach" target="blank">
                        View
                      </a>{" "}
                      for AMFI Best Practices Guidelines Circular No.110
                      /2023-24 Revised AMFI Best Practice Guidelines for
                      transmission of Mutual Fund units.
                    </p> */}
                    <ul>
                      <li>
                        <a href={TransmissionMatrix} target="blank">
                          Please View Transmission Documentation Grid.
                        </a>
                      </li>
                      <li>
                        <a href={TransmissionMatrix} target="blank">
                          Transmission Matrix
                        </a>
                      </li>
                      <li>
                        <a href={FormQtp1} target="blank">
                         FORM-QTP with Nominee
                        </a>
                      </li>
                      <li>
                        <a href={FormQtp2} target="blank">
                          FORM-QTP without Nominee
                        </a>
                      </li>
                      <li>
                        <a href={DeletionRequest} target="blank">
                         FORM-1 Request for Deletion of name(s) of Joint Holders in case of death of the 1st and 2nd Joint Holders
                        </a>
                      </li>
                      <li>
                        <a href={TransmissionRequest} target="blank">
                         FORM-2 Request for Transmission of Units by Surviving Joint Holder(s) on demise of 1st unit holder
                        </a>
                      </li>
                      <li>
                        <a href={TransmissionRequest3} target="blank">
                         FORM-3 Transmission Request Form (under Simplified category and other than QTP Category)
                        </a>
                      </li>
                      <li>
                        <a href={KartaClaimaint} target="blank">
                         FORM-4 Transmission to New Karta_Claimant (on death of HUF Karta or on Dissolution of HUF)
                        </a>
                      </li>
                      <li>
                        <a href={BondOfIndeminity} target="blank">
                         BOND OF INDEMNITY
                        </a>
                      </li>
                      <li>
                        <a
                          href={BondOfIndeminityKarta}
                          target="blank"
                        >
                          BOND OF INDEMNITY-Change of Karta
                        </a>
                      </li>
                      <li>
                        <a href={BankDetails} target="blank">
                          Bank Attestation of Signature & bank account details
                        </a>
                      </li>
                      <li>
                        <a href={BankDetailsNewKarta} target="blank">
                         Bank Attestation of Signature of new Karta
                        </a>
                      </li>
                      <li>
                        <a href={AffidavitNOC} target="blank">
                          Affidavit cum NOC
                        </a>
                      </li>
                      {/* <li>
                        <a href={MFNominationForm} target="blank">
                          Nomination Form{" "}
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    </>
  );
}

export default TransmissionUnits;
